import React, { useState, useEffect } from "react";
import InputField from "common/customInputField";
import Button from "react-bootstrap/Button";
import FloorMapCard from "components/siteRepo/common/floorMapCard";
import Modal from "common/modal";
import GooglePlaces from "common/googlePlaces";
import { useNavigate } from "react-router-dom";
import AccountLookup from "common/accountLookup";
import StoreLookup from "common/storeLookup";
import { isPossiblePhoneNumber, parsePhoneNumber, formatPhoneNumber } from "react-phone-number-input";
import { geocodeByAddress } from "react-places-autocomplete";
import SelectInput from "common/selectInput";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import NoAccessPage from "common/noAccessPage";
import { submitCreateNewSite, getSiteDetails, deleteFloor } from "store/siteRepo/actionCreator";
import { showSpinner, hideSpinner } from "store/slices/spinner";
import { updateSelectLayer, updateEditSiteDetailsFields, setEditSiteData } from "store/slices/siteRepo";
import { api } from "store/slices/api";
import { createValidationRules } from "../utils";
import { toast } from "react-toastify";

const SiteDetails = () => {
  const dispatch = useDispatch();
  const { data: statesList = [] } = api.useGetStatesQuery();
  const { projects } = useSelector((state) => state.siteRepo.editSite.selectedData);
  const [isShowDeleteLayerModal, setIsShowDeleteLayerModal] = useState(false);
  const [deleteLayerSelectedData, setDeleteLayerSelectedData] = useState({});
  const [isValidStoreLookup, setIsValidStoreLookup] = useState(true);
  const [accountDefaultData, setAccountDefaultData] = useState(null);
  const [storeDefaultData, setStoreDefaultData] = useState(null);
  const [isShowAddFloorPlanModal, setIsShowAddFloorPlanModal] = useState(false);
  const [addFloorPlanModalData, setAddFloorPlanModalData] = useState({});
  const [isAddingFloorPlan, setIsAddingFloorPlan] = useState(false);
  const [isShowProjectTabActive, setIsShowProjectTabActive] = useState(false);
  const [siteNameValid, setSiteNameValid] = useState("");
  const [siteStreetValid, setSiteStreetValid] = useState("");
  const [siteAddressValid, setSiteAddressValid] = useState("");
  const [siteCityValid, setSiteCityValid] = useState("");
  const [siteZipValid, setSiteZipValid] = useState("");
  const [parentNameValid, setParentNameValid] = useState("");
  const [contactNameValid, setContactNameValid] = useState("");
  const [contactPhoneNumberValid, setContactPhoneNumberValid] = useState("");
  const [terrValid, setTerrValid] = useState("");
  const { sub, terrCcn, storeCcn } = useSelector((state) => state.loggedInUser);
  const { siteId } = useParams();
  const { viewSite, editSite } = useSelector((state) => state.siteRepo);
  const { storeNumber, accountNumber, territory, siteName, siteAddress, siteCity, siteStreet, siteZip } = editSite;
  const [isShowAccessConfirmationModal, setIsShowAccessConfirmationModal] = useState(false);
  const [isEditingSite, setIsEditingSite] = useState(false);
  const [accountValid, setAccountValid] = useState(true);

  const validationRules = createValidationRules({
    setSiteNameValid,
    setTerrValid,
    setSiteStreetValid,
    setSiteCityValid,
    setSiteZipValid,
    setParentNameValid,
    setContactNameValid,
    setContactPhoneNumberValid,
  });
  useEffect(() => {
    if (!(viewSite?.siteId === siteId)) {
      dispatch(getSiteDetails(siteId)).then((res) => dispatch(setEditSiteData(res)));
    } else {
      dispatch(setEditSiteData(viewSite));
    }
  }, [viewSite]);

  useEffect(() => {
    if (editSite?.storeNumber && storeDefaultData === null) {
      setStoreDefaultData({ storeNumber: editSite.storeNumber, storeName: editSite.storeName });
    }

    if (editSite?.accountNumber && accountDefaultData === null) {
      setAccountDefaultData({ accountNumber: editSite.accountNumber, accountName: editSite.accountName });
    }
  }, [accountNumber, storeNumber]);

  const navigate = useNavigate();

  useEffect(() => {
    let tempDta = false;
    projects?.some((project) => {
      if (project.layersInfo?.length > 1) {
        tempDta = true;
      }
    });

    let editDta = false;
    editSite?.projectDetailsList?.some((project) => {
      if (project.layerInfoList?.length > 1) {
        editDta = true;
      }
    });

    if (tempDta || editDta) {
      setIsShowProjectTabActive(true);
    } else {
      setIsShowProjectTabActive(false);
    }
  }, [projects, editSite]);

  const handleDeleteLayerModal = (isShow) => {
    if (isShow) {
      setIsShowDeleteLayerModal(true);
    } else {
      setIsShowDeleteLayerModal(false);
    }
  };

  const handleDeleteLayer = (data) => {
    setDeleteLayerSelectedData(data);
    setIsShowDeleteLayerModal(true);
  };

  const handleAddressChange = (address) => {
    const key = event.target.id;
    const value = address;
    if (key === "siteAddress") {
      if (value.length > 200) {
        setSiteAddressValid("Cannot exceed 200 characters.");
      } else if (value.length <= 200) {
        setSiteAddressValid("");
      }
    }
    dispatch(updateEditSiteDetailsFields({ key, value }));
  };

  const handleFieldsChange = (e, a) => {
    dispatch(updateEditSiteDetailsFields({ key: "siteState", value: a.id }));
  };

  const handleSiteDetailsChange = (e) => {
    const key = e.target.id;
    const value = e.target.value;
    dispatch(updateEditSiteDetailsFields({ key, value }));
    const validation = validationRules[key];

    if (validation) {
      validation.setter("");
      if (validation.maxLength && value.length > validation.maxLength) {
        validation.setter(validation.errorMsg);
      } else if (validation.requiredLength && value.length < validation.requiredLength) {
        validation.setter(validation.errorMsg);
      }
    }
  };
  const handleAddressSelect = (address) => {
    dispatch(showSpinner());
    const key = "siteAddress";
    const addressComponent = {
      siteState: "",
      siteCity: "",
      siteZip: "",
      siteStreetNumber: "",
      siteStreetName: "",
    };
    let composedAddress;
    geocodeByAddress(address).then((results) => {
      const place = results[0];
      for (const component of place.address_components) {
        const componentType = component.types[0];
        switch (componentType) {
          case "administrative_area_level_1":
            addressComponent.siteState = component.short_name + ", ";
            break;
          case "locality":
            addressComponent.siteCity = component.long_name + ", ";
            break;
          case "administrative_area_level_2":
            if (addressComponent.siteCity === "") {
              addressComponent.siteCity = component.long_name + ", ";
            }
            break;
          case "postal_code":
            addressComponent.siteZip = component.long_name;
            break;
          case "street_number":
            addressComponent.siteStreetNumber = component.long_name + ", ";
            break;
          case "route":
            addressComponent.siteStreetName = component.long_name + ", ";
            break;
        }
      }
      composedAddress = `${addressComponent.siteStreetNumber || ""}${addressComponent.siteStreetName || ""}${
        addressComponent.siteCity || ""
      }${addressComponent.siteState || ""}${addressComponent.siteZip || ""}`;
      dispatch(updateEditSiteDetailsFields({ key, value: composedAddress }));

      for (const component in addressComponent) {
        if (component === "siteState" || component === "siteCity" || component === "siteZip") {
          setTimeout(
            () =>
              dispatch(
                updateEditSiteDetailsFields({ key: component, value: addressComponent[component].replaceAll(",", "") }),
              ),
            0,
          );
        }
      }

      dispatch(
        updateEditSiteDetailsFields({
          key: "siteStreet",
          value: addressComponent.siteStreetNumber + addressComponent.siteStreetName?.replaceAll(",", ""),
        }),
      );
      dispatch(hideSpinner());
    });
  };

  const handleRemoveLayer = (selectionData) => {
    const { type, data } = selectionData;
    if (type === "layer") {
      if (data.layer?.layerId) {
        const deleteFloorRequestObject = {
          projectId: data.project.projectId,
          layerId: data.layer?.layerId,
          siteId,
          updatedBy: sub,
        };
        dispatch(deleteFloor(data.project.projectId, deleteFloorRequestObject));
      } else {
        dispatch(
          updateSelectLayer({
            selectLayerProjectIndex: data.projectIndex,
            selectLayerLayerIndex: data.layerIndex,
            isEdit: true,
          }),
        );
      }
    }
    handleDeleteLayerModal(false);
  };

  const updateSite = () => {
    if ((territory === terrCcn && territory !== "800100") || storeCcn === storeNumber) {
      confirmUpdateSite();
    } else {
      setIsShowAccessConfirmationModal(true);
    }
  };

  const handleAccessModalCancel = () => {
    setIsShowAccessConfirmationModal(false);
  };

  const confirmUpdateSite = () => {
    if (isEditingSite) {
      return;
    }
    const {
      siteName,
      siteAddress,
      siteCity,
      siteState,
      accountNumber,
      accountName,
      storeNumber,
      storeName,
      siteZip,
      siteStreet,
      parentNumber,
      phoneNumber,
      parentName,
      execName,
      execNumber,
      contactName,
      customerName,
      storePhone,
      accountCity,
      accountStreet,
      accountZip,
      accountState,
      projectDetailsList,
      territory,
    } = editSite;

    const projectDetailsListClone = JSON.parse(JSON.stringify(projectDetailsList));

    if (projects?.length > 0) {
      projects.map((project) => {
        const isExistingProject = projectDetailsListClone.some((existingProject) => {
          if (existingProject.mprojectId === project.mprojectId) {
            existingProject.layerInfoList = [...project.layersInfo];
          }
          return existingProject.mprojectId === project.mprojectId;
        });
        if (!isExistingProject) {
          projectDetailsListClone.push(project);
        }
      });
    }

    const updateSiteRequestObject = {
      siteId,
      siteName,
      siteAddress,
      siteCity,
      siteState,
      accountNumber,
      accountName,
      storeNumber,
      storeName,
      updatedBy: sub,
      siteZip,
      siteStreet,
      parentNumber,
      phoneNumber,
      parentName,
      execName,
      execNumber,
      contactName,
      customerName,
      storePhone,
      accountCity,
      accountStreet,
      accountZip,
      accountState,
      territory,
      projectDetailsList: projectDetailsListClone.map((projectItem) => {
        const layerList = projectItem.layerInfoList ? projectItem.layerInfoList : projectItem.layersInfo;
        const {
          mprojectId,
          projectId,
          name,
          creatorM2Id,
          isArchived,
          lastUpdatedOn,
          ownerM2Id,
          revision,
          usedM2Id,
          size,
          floorPlanNotes,
          installerNotes,
          specialInstructions,
        } = projectItem;
        let updationType = "old";
        return {
          mprojectId,
          projectId: projectId ? projectId : "",
          name,
          updatedBy: sub,
          creatorM2Id,
          isArchived,
          lastUpdatedOn,
          ownerM2Id,
          revision,
          usedM2Id,
          size,
          floorPlanNotes,
          installerNotes,
          specialInstructions,
          layerInfoList: layerList
            .filter((layer) => layer.isSelected)
            .map((layer) => {
              const { name, index, layerId, createdBy, measureSquareLayer, shapeId } = layer;
              if (!layerId) {
                updationType = "new";
              }
              return {
                layerId: layerId ? layerId : "",
                projectId: projectId ? projectId : "",
                name,
                index,
                measureSquareLayer,
                shapeId,
                createdBy: createdBy ? "" : sub,
                updatedBy: sub,
                projectName: layer.projectName ? layer.projectName : projectItem.name,
                rooms: layer.rooms
                  ? layer.rooms.map((room) => {
                      const { area, perimeter, name, roomId, createdBy, length, width, type } = room;
                      return {
                        roomId: roomId ? roomId : "",
                        layerId: layerId ? layerId : "",
                        area,
                        perimeter,
                        name,
                        createdBy: createdBy ? "" : sub,
                        length,
                        width,
                        type,
                        updatedBy: sub,
                        products: room.products
                          ? room.products.map((product) => {
                              const {
                                id,
                                netArea,
                                quantity,
                                wasteRatio,
                                sellByBox,
                                unitsPerBox,
                                boxName,
                                taxable,
                                roomInfoId,
                                boxCostPrice,
                                boxSalesPrice,
                                color,
                                costPrice,
                                createdBy,
                                desc,
                                manufacturer,
                                salesPrice,
                                trade,
                                type,
                                unit,
                                vendor,
                                vendorSku,
                                categoryCode,
                                actualUsage,
                                waste,
                                modActualUsage,
                                modWaste,
                                salesNumber,
                              } = product;
                              return {
                                roomInfoId: roomInfoId ? roomInfoId : "",
                                roomId: roomId ? roomId : "",
                                id,
                                netArea,
                                quantity,
                                wasteRatio,
                                sellByBox,
                                unitsPerBox,
                                boxName,
                                taxable,
                                updatedBy: sub,
                                boxCostPrice,
                                boxSalesPrice,
                                color,
                                costPrice,
                                createdBy,
                                desc,
                                manufacturer,
                                salesPrice,
                                trade,
                                type,
                                unit,
                                vendor,
                                vendorSku,
                                categoryCode,
                                actualUsage,
                                waste,
                                modActualUsage,
                                modWaste,
                                salesNumber,
                              };
                            })
                          : [],
                      };
                    })
                  : [],
              };
            }),
          updateType: updationType,
        };
      }),
    };

    updateSiteRequestObject.projectDetailsList?.map((project) => {
      project.layerInfoList?.map((layer) => {
        if (!layer.layerId) {
          let productsObj = {};
          layer.rooms?.map((room) => {
            room.products?.map((product) => {
              productsObj[product.id] = productsObj[product.id] ? productsObj[product.id] : {};

              if (product.netArea) {
                if (productsObj[product.id].netAreaSum) {
                  productsObj[product.id].netAreaSum += parseFloat(product.netArea);
                } else {
                  productsObj[product.id].netAreaSum = parseFloat(product.netArea);
                }
              }

              if (product.quantity) {
                if (productsObj[product.id].quantitySum) {
                  productsObj[product.id].quantitySum += parseFloat(product.quantity);
                } else {
                  productsObj[product.id].quantitySum = parseFloat(product.quantity);
                }
              }

              if (product.sellByBox && productsObj[product.id] && productsObj[product.id].sellByBox === undefined) {
                productsObj[product.id].sellByBox = product.sellByBox;
              }
            });
          });

          layer.rooms?.map((room) => {
            room.products?.map((product) => {
              if (product.sellByBox) {
                product.actualUsage =
                  Math.ceil(parseFloat(productsObj[product.id].quantitySum) / parseFloat(product.unitsPerBox)) *
                  parseFloat(product.unitsPerBox);
                product.waste =
                  ((parseFloat(product.actualUsage) - productsObj[product.id].netAreaSum) /
                    productsObj[product.id].netAreaSum) *
                  100;
                product.modActualUsage = null;
                product.modWaste = null;
              } else {
                product.actualUsage = parseFloat(productsObj[product.id].quantitySum);
                product.waste =
                  ((productsObj[product.id].quantitySum - productsObj[product.id].netAreaSum) /
                    productsObj[product.id].quantitySum) *
                  100;
                product.modActualUsage = null;
                product.modWaste = null;
              }
              if (product.unit !== "SF" && product.unit !== "LF") {
                if (product.unit === "SY") {
                  product.actualUsage = Math.round(product.actualUsage * 9);
                  product.unit = "SF";
                } else if (product.unit === "LY") {
                  product.actualUsage = Math.round(product.actualUsage * 3);
                  product.unit = "LF";
                }
              }
            });
          });
        }
      });
    });

    let valid = true;
    setSiteNameValid("");
    setTerrValid("");
    setSiteStreetValid("");
    setSiteCityValid("");
    setSiteAddressValid("");
    setParentNameValid("");
    setContactPhoneNumberValid("");
    setContactNameValid("");
    if (siteStreet?.length > 100) {
      valid = false;
      setSiteStreetValid("Cannot exceed 100 characters.");
      window.scrollTo(0, 0);
    }
    if (siteCity?.length > 50) {
      valid = false;
      setSiteCityValid("Cannot exceed 50 characters.");
      window.scrollTo(0, 0);
    }
    if (siteZip?.length > 10) {
      valid = false;
      setSiteZipValid("Cannot exceed 10 characters.");
      window.scrollTo(0, 0);
    }
    if (siteAddress?.length > 200) {
      valid = false;
      setSiteAddressValid("Cannot exceed 100 characters.");
      window.scrollTo(0, 0);
    }
    if (parentName?.length > 100) {
      valid = false;
      setParentNameValid("Cannot exceed 100 characters.");
      var elem = document.getElementById("parentSectionScroll");
      elem.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    if (contactName?.length > 61) {
      valid = false;
      setContactNameValid("Cannot exceed 61 characters.");
    }
    if (phoneNumber) {
      if (!isPossiblePhoneNumber("+1" + phoneNumber)) {
        valid = false;
        setContactPhoneNumberValid("Invalid Phone Number.");
        var elem = document.getElementById("parentSectionScroll");
        elem.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        let result = parsePhoneNumber("+1" + phoneNumber);
        updateSiteRequestObject.phoneNumber = result.nationalNumber;
      }
    }
    if (siteName?.length > 40) {
      valid = false;
      setSiteNameValid("Cannot exceed 40 characters.");
      window.scrollTo(0, 0);
    } else if (territory?.length < 6) {
      valid = false;
      setTerrValid("Please enter 6 digits");
    } else if (!territory || territory === "") {
      valid = false;
      setTerrValid("Please enter Territory Number");
    }

    if (valid) {
      setIsEditingSite(true);

      toast
        .promise(dispatch(submitCreateNewSite(updateSiteRequestObject)), {
          pending: "Editing Site",
          success: "Site edited successfully",
          error: "Could not edit site, please try again.",
        })
        .then((res) => {
          navigate(`/siteRepo/site/${res.siteId}`);
        })
        .catch(() => {})
        .finally(() => setIsEditingSite(false));
    }
  };

  const onStoreNumberChange = (strNum, isValid, storeData) => {
    dispatch(updateEditSiteDetailsFields({ key: "storeNumber", value: strNum }));
    if (isValid) {
      setAditionalStoreFields(storeData);
    }
  };

  const onStoreNameChange = (strName, isValid, storeData) => {
    dispatch(updateEditSiteDetailsFields({ key: "storeName", value: strName }));
    if (isValid) {
      setAditionalStoreFields(storeData);
    }
  };

  const onStoreLookupValidation = (isValid) => {
    if (isValid !== isValidStoreLookup) {
      setIsValidStoreLookup(isValid);
    }
  };

  const setAditionalAccountFields = (accountData) => {
    for (const key in accountData) {
      let renamedKey = key;
      if (key === "city") {
        renamedKey = "accountCity";
      } else if (key === "street") {
        renamedKey = "accountStreet";
      } else if (key === "zip") {
        renamedKey = "accountZip";
      } else {
        renamedKey = key;
      }
      setTimeout(() => dispatch(updateEditSiteDetailsFields({ key: renamedKey, value: accountData[key] })), 0);
    }
  };

  const setAditionalStoreFields = (storeData) => {
    setTimeout(
      () => dispatch(updateEditSiteDetailsFields({ key: "storePhone", value: storeData["storePhoneNumber"] })),
      0,
    );
  };

  const handleAddFloorPlanModal = (isShow) => {
    setIsShowAddFloorPlanModal(isShow);
  };

  const confirmAddFloorPlan = () => {
    const {
      siteName,
      siteAddress,
      siteCity,
      siteState,
      accountNumber,
      accountName,
      storeNumber,
      storeName,
      siteZip,
      siteStreet,
      parentNumber,
      phoneNumber,
      parentName,
      execName,
      execNumber,
      contactName,
      customerName,
      storePhone,
      accountCity,
      accountStreet,
      accountZip,
      accountState,
      territory,
    } = viewSite;
    const addFloorPlanReqObj = {
      siteId,
      siteName,
      siteAddress,
      siteCity,
      siteState,
      accountNumber,
      accountName,
      storeNumber,
      storeName,
      siteZip,
      siteStreet,
      parentNumber,
      phoneNumber,
      parentName,
      execName,
      execNumber,
      contactName,
      customerName,
      storePhone,
      accountCity,
      accountStreet,
      accountZip,
      accountState,
      territory,
      projectDetailsList: [
        {
          mprojectId: "",
          name: addFloorPlanModalData.projectName,
          createdBy: sub,
          updateType: "old",
          layerInfoList: [
            {
              name: addFloorPlanModalData.layerName,
              createdBy: sub,
              projectName: addFloorPlanModalData.projectName,
              rooms: [],
            },
          ],
        },
      ],
    };

    if (isAddingFloorPlan) {
      return;
    }
    setIsAddingFloorPlan(true);

    toast
      .promise(dispatch(submitCreateNewSite(addFloorPlanReqObj)), {
        pending: "Adding Floor Plan",
        success: "Floor plan added successfully",
        error: "Could not add floor plan, please try again.",
      })
      .then((res) => {
        handleAddFloorPlanModal(false);
        dispatch(getSiteDetails(res.siteId));
      })
      .catch(() => {})
      .finally(() => setIsAddingFloorPlan(false));
  };

  const onAddFloorFieldsChange = (e) => {
    const { id, value } = e.target;
    setAddFloorPlanModalData({ ...addFloorPlanModalData, [id]: value });
  };

  if ((viewSite.territory !== terrCcn || viewSite.territory === "800100") && storeCcn !== viewSite.storeNumber) {
    return <NoAccessPage />;
  }

  return (
    <div className="mt-5 mt-md-0 create-site-details-container d-flex flex-column justify-content-between">
      <div className="search-form-container px-0 border-0">
        <div className="search-form-container__fields">
          <form className="search-form-container__fields__form">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label={"Site Name"}
                  id="siteName"
                  placeholder="Enter a site name"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={editSite.siteName}
                  onChange={(e) => handleSiteDetailsChange(e)}
                  disabled={false}
                  isRequired={true}
                  errorMsg={siteNameValid}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 search-form-container__fields__form-group">
                <GooglePlaces
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  label={"Site Address"}
                  id="siteAddress"
                  isRequired={true}
                  onChange={handleAddressChange}
                  value={editSite.siteAddress}
                  onSelect={handleAddressSelect}
                  placeholder="Choose your site address"
                  debounce={1000}
                  errorMsg={siteAddressValid}
                />
                {siteAddressValid && (
                  <div className="form-group">
                    <p className="error-etext error-undefined mb-0">{siteAddressValid}</p>
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label={"Street"}
                  id="siteStreet"
                  placeholder={"Enter Street"}
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={editSite.siteStreet}
                  onChange={(e) => handleSiteDetailsChange(e)}
                  disabled={false}
                  isRequired={true}
                  errorMsg={siteStreetValid}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label={"City"}
                  id="siteCity"
                  placeholder={"Enter City"}
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={editSite.siteCity}
                  onChange={(e) => handleSiteDetailsChange(e)}
                  disabled={false}
                  isRequired={true}
                  errorMsg={siteCityValid}
                />
              </div>
            </div>
            <div className="row" id="taxabilityScroll">
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 search-form-container__fields__form-group">
                <SelectInput
                  options={statesList}
                  label={"State"}
                  defaultValue={"Select a state"}
                  value={editSite.siteState}
                  disabled={false}
                  isRequired={true}
                  id="siteState"
                  handleSelectInput={(e, value) => {
                    handleFieldsChange(e, value);
                  }}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label={"Zip"}
                  id="siteZip"
                  placeholder={"Enter Zip"}
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={editSite.siteZip}
                  onChange={(e) => handleSiteDetailsChange(e)}
                  disabled={false}
                  isRequired={true}
                  errorMsg={siteZipValid}
                />
              </div>
            </div>
            <AccountLookup
              numberFieldChangeCallback={(accNo, isValid, accountData) => {
                setAccountValid(isValid);
                dispatch(updateEditSiteDetailsFields({ key: "accountNumber", value: accNo }));
                setAditionalAccountFields(accountData);
                if (accountData?.contactName) {
                  dispatch(updateEditSiteDetailsFields({ key: "contactName", value: accountData.contactName }));
                }
              }}
              nameFieldChangeCallback={(accName, _isValid, accountData) => {
                dispatch(updateEditSiteDetailsFields({ key: "accountName", value: accName }));
                setAditionalAccountFields(accountData);
                if (accountData?.contactName) {
                  dispatch(updateEditSiteDetailsFields({ key: "contactName", value: accountData.contactName }));
                }
              }}
              initialAccountNumber={editSite.accountNumber}
              initialAccountName={editSite.accountName}
            />
            <div className="row" id="parentSectionScroll">
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label={"Parent Number"}
                  id="parentNumber"
                  placeholder={"Enter Parent Number"}
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={editSite.parentNumber ?? ""}
                  onChange={(e) => handleSiteDetailsChange(e)}
                  disabled={false}
                  isRequired={false}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label={"Parent Name"}
                  id="parentName"
                  placeholder={"Enter Parent Name"}
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={editSite.parentName ?? ""}
                  onChange={(e) => handleSiteDetailsChange(e)}
                  disabled={false}
                  isRequired={false}
                  errorMsg={parentNameValid}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label={"Contact Phone Number"}
                  id="phoneNumber"
                  placeholder={"Enter Contact Phone Number"}
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  disabled={false}
                  isRequired={false}
                  value={
                    editSite.phoneNumber
                      ? editSite.phoneNumber.length > 1
                        ? formatPhoneNumber("+1" + editSite.phoneNumber)
                        : editSite.phoneNumber
                      : ""
                  }
                  onChange={(e) => handleSiteDetailsChange(e)}
                  errorMsg={contactPhoneNumberValid}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label={"Contact Name"}
                  id="contactName"
                  placeholder={"Enter Contact Name"}
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={editSite.contactName}
                  onChange={(e) => handleSiteDetailsChange(e)}
                  disabled={false}
                  isRequired={false}
                  errorMsg={contactNameValid}
                />
              </div>
            </div>
            <StoreLookup
              numberFieldChangeCallback={onStoreNumberChange}
              nameFieldChangeCallback={onStoreNameChange}
              onStoreLookupValidation={onStoreLookupValidation}
              debounceValue={1000}
              defaultData={storeDefaultData}
              clearDefaultData={() => setStoreDefaultData({})}
              requiredFields={true}
            />
            <div className="col-12 col-sm-12 col-md-5 col-lg-5 search-form-container__fields__form-group">
              <InputField
                type="text"
                label={"Territory Number"}
                id="territory"
                placeholder={"Enter Territory Number"}
                fieldClasses="form-control search-form-container__fields__form-group__item"
                value={editSite.territory}
                onChange={(e) => handleSiteDetailsChange(e)}
                disabled={false}
                isRequired={true}
                errorMsg={terrValid}
              />
            </div>
            <div className="row selected-projects">
              <div className="search-form-container__title d-flex align-items-md-center justify-content-md-between flex-column justify-content-start flex-md-row">
                <div className="d-flex mb-4 mb-md-0">
                  <span className="search-form-container__title--text w-auto">Floor Plans (Projects)</span>
                </div>
                <div>
                  <Button variant="outline-primary" onClick={() => handleAddFloorPlanModal(true)}>
                    Add Floor Plan
                  </Button>
                  <Button
                    className="m-0"
                    variant="outline-primary"
                    onClick={() => navigate(`/siteRepo/editSite/${siteId}#select-project-editable`)}
                  >
                    Update Measure Square Projects
                  </Button>
                </div>
              </div>

              {isShowProjectTabActive ? (
                <div className="container-proj">
                  {editSite?.projectDetailsList?.map((project, idx) => {
                    return (
                      <div className="project-container" key={idx + project.projectId + project.name}>
                        <div className="col-12 d-flex proj-header justify-content-between">
                          <div className="d-flex align-items-center">
                            <span className="item-header">Floor Plan (Project) Name: </span>
                            <span className="item-label">{project.name}</span>
                          </div>
                        </div>

                        <div className="row floors">
                          <div className="d-flex flex-column flex-md-row flex-wrap">
                            {project.layerInfoList?.length &&
                              project.layerInfoList.map((layerItem, index) => {
                                return (
                                  <FloorMapCard
                                    key={index}
                                    layerIndex={layerItem.elementIndex}
                                    layerObject={layerItem}
                                    handleSelection={() => {}}
                                    project={project}
                                    isSiteDetails={true}
                                    isSelectable={false}
                                    projectView={true}
                                    removeLayerAction={handleDeleteLayer}
                                  />
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {projects.map((project, idx) => {
                    return (
                      <div className="project-container" key={idx + project.projectId + project.name}>
                        <div className="col-12 d-flex proj-header justify-content-between">
                          <div className="d-flex align-items-center">
                            <span className="item-header">Floor Plan (Project) Name: </span>
                            <span className="item-label">{project.name}</span>
                          </div>
                        </div>

                        <div className="row floors">
                          <div className="d-flex flex-column flex-md-row flex-wrap">
                            {project.layersInfo?.length &&
                              project.layersInfo.map((layerItem, index) => {
                                if (layerItem.isSelected) {
                                  return (
                                    <FloorMapCard
                                      key={index}
                                      layerIndex={layerItem.elementIndex}
                                      handleSelection={() => {}}
                                      project={project}
                                      isSiteDetails={true}
                                      projectView={true}
                                      isSelectable={false}
                                      removeLayerAction={handleDeleteLayer}
                                    />
                                  );
                                }
                              })}
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {editSite?.projectDetailsList && editSite.projectDetailsList.length === 0 && projects.length === 0 ? (
                    <div className="d-flex w-100 align-items-center justify-content-center">
                      <div className="alert alert-warning no-rooms-info mt-4" role="alert">
                        No Floorplans available. Consider adding one!
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div className="d-flex flex-column flex-md-row flex-wrap">
                  {editSite?.projectDetailsList?.map((project) => {
                    return (
                      project.layerInfoList?.length &&
                      project.layerInfoList.map((layerItem, index) => {
                        return (
                          <FloorMapCard
                            key={index}
                            layerIndex={layerItem.elementIndex}
                            layerObject={layerItem}
                            handleSelection={() => {}}
                            project={project}
                            isSiteDetails={true}
                            isSelectable={false}
                            removeLayerAction={handleDeleteLayer}
                          />
                        );
                      })
                    );
                  })}
                  {projects.map((project) => {
                    return (
                      project.layersInfo?.length &&
                      project.layersInfo.map((layerItem, index) => {
                        if (layerItem.isSelected) {
                          return (
                            <FloorMapCard
                              key={index}
                              layerIndex={layerItem.elementIndex}
                              handleSelection={() => {}}
                              project={project}
                              isSiteDetails={true}
                              isSelectable={false}
                              removeLayerAction={handleDeleteLayer}
                            />
                          );
                        }
                      })
                    );
                  })}

                  {editSite?.projectDetailsList && editSite.projectDetailsList.length === 0 && projects.length === 0 ? (
                    <div className="d-flex w-100 align-items-center justify-content-center">
                      <div className="alert alert-warning no-rooms-info mt-4" role="alert">
                        No Floorplans available. Consider adding one!
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          </form>
        </div>
      </div>

      {isShowAccessConfirmationModal && (
        <Modal
          title={"Are you Sure?"}
          handleSave={confirmUpdateSite}
          handleCancel={handleAccessModalCancel}
          size={"lg"}
          sectionName={""}
          closeButtonText={"No"}
          saveButtonText={"Yes"}
          isSaveBtnDisabled={isEditingSite}
        >
          <>
            <p className="confirmation-text">
              You will no longer have access to edit this site after saving these changes because your store and
              territory do not match the site. Are you sure you want to save these changes?
            </p>
          </>
        </Modal>
      )}

      {isShowDeleteLayerModal && (
        <Modal
          title={"Are you Sure?"}
          handleSave={() => handleRemoveLayer({ ...deleteLayerSelectedData })}
          handleCancel={() => handleDeleteLayerModal(false)}
          size={"lg"}
          sectionName={""}
          bodyClass={"account-lookup-search-form"}
          closeButtonText={"Cancel"}
          saveButtonText={"Remove"}
          saveButtonClass={"btn-primary remove"}
        >
          <>
            <div className="container-fluid search-form-container border-0 m-0">
              <p>
                Are you sure you want to remove the{" "}
                <b>
                  {deleteLayerSelectedData.data.layerName} - {deleteLayerSelectedData.data.projectName}
                </b>{" "}
                unit from the selected list?
              </p>
            </div>
          </>
        </Modal>
      )}
      {isShowAddFloorPlanModal && (
        <Modal
          title={"Add Floor Plan"}
          handleSave={confirmAddFloorPlan}
          handleCancel={() => handleAddFloorPlanModal(false)}
          size={"lg"}
          sectionName={""}
          closeButtonText={"Cancel"}
          saveButtonText={"Add"}
          isSaveBtnDisabled={isAddingFloorPlan}
        >
          <>
            <div className="container-fluid p-2 border-0 m-0">
              <div className="search-form-container__fields">
                <form className="search-form-container__fields__form">
                  <div className="row align-items-center">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                      <InputField
                        type="text"
                        id="projectName"
                        label="Floor Plan Name"
                        placeholder={"Enter Floor Plan Name"}
                        fieldClasses="form-control search-form-container__fields__form-group__item"
                        value={addFloorPlanModalData.projectName || ""}
                        onChange={(e) => onAddFloorFieldsChange(e)}
                      />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                      <InputField
                        type="text"
                        id="layerName"
                        label="Floor Name"
                        placeholder={"Enter Floor Name"}
                        fieldClasses="form-control search-form-container__fields__form-group__item"
                        value={addFloorPlanModalData.layerName || ""}
                        onChange={(e) => onAddFloorFieldsChange(e)}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </>
        </Modal>
      )}
      <div className="d-flex justify-content-between flex-column-reverse flex-md-row">
        <Button variant="outline-primary" onClick={() => navigate(`/siteRepo/site/${viewSite.siteId}`)}>
          Cancel
        </Button>
        <Button
          className="m-0"
          variant="primary"
          onClick={updateSite}
          disabled={
            !siteName?.length ||
            !siteAddress?.length ||
            !siteCity?.length ||
            !siteStreet?.length ||
            !siteZip?.length ||
            !territory?.length ||
            !isValidStoreLookup ||
            !accountValid ||
            isEditingSite
          }
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default SiteDetails;
